import { createFileRoute, notFound } from '@tanstack/react-router'

import keycloak from '@/core/keycloak'
import Welcome from '@/signup/components/Welcome'

export const Route = createFileRoute('/signup/credentials/{-$uuid}')({
  beforeLoad: async () => {
    if (keycloak.authenticated) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Welcome />
}
